import Handlebars from "handlebars";
import dealRoomAttachmentTemplate from "./DealRoomAttachment.handlebars.js";

Handlebars.registerPartial('DealRoomAttachment', dealRoomAttachmentTemplate);

const templateString = `
  <div class="sectionCard" style="margin:0;max-width: 37.5rem;">
    <!--[if mso | IE]>
      <table width=37.5rem; role="presentation" border="0" cellpadding="0" cellspacing="0">
    <![endif]-->
      {{> DealRoomAttachment}}
    <!--[if mso | IE]>
      </table>
    <![endif]-->
  </div>
`;

const template = Handlebars.compile(templateString);

export default template;
